import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from './api';

const DataContext = createContext({});

export function DataProvider({ children }) {
  const [campanas, setCampanas]     = useState([]);
  const [llamadas, setLlamadas]     = useState([]);
  const [billing, setBilling]       = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [filtroFechaDesde, setFiltroFechaDesde] = useState('');
  const [filtroFechaHasta, setFiltroFechaHasta] = useState('');

  const refrescar = useCallback(async () => {
    try {
      const [c, l, b] = await Promise.all([
        api.get('/campaigns/'),
        api.get('/calls?limit=500'),
        api.get('/billing/summary').catch(() => ({ data: null })),
      ]);
      setCampanas(c.data);
      setLlamadas(l.data);
      setBilling(b.data);
      setLastUpdate(new Date());
    } catch {}
  }, []);

  useEffect(() => { refrescar(); }, [refrescar]);

  useEffect(() => {
    const interval = setInterval(refrescar, 5000);
    return () => clearInterval(interval);
  }, [refrescar]);

  // Llamadas filtradas por fecha — disponible globalmente
  const llamadasFiltradas = llamadas.filter(c => {
    if (filtroFechaDesde) {
      if (new Date(c.date_updated) < new Date(filtroFechaDesde)) return false;
    }
    if (filtroFechaHasta) {
      const hasta = new Date(filtroFechaHasta);
      hasta.setHours(23, 59, 59);
      if (new Date(c.date_updated) > hasta) return false;
    }
    return true;
  });

  return (
    <DataContext.Provider value={{
      campanas, setCampanas,
      llamadas, llamadasFiltradas,
      billing, refrescar, lastUpdate,
      filtroFechaDesde, setFiltroFechaDesde,
      filtroFechaHasta, setFiltroFechaHasta,
    }}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
